const $$splitComponentImporter = () => import('/home/runner/work/nexus/nexus/apps/frontend/src/routes/(app)/org/$org/objectives/index.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { createFileRoute } from '@tanstack/react-router';
import i18n from '@/lib/translations/i18n';
export const Route = createFileRoute('/(app)/org/$org/objectives/')({
  staticData: {
    hideChrome: true,
    topNav: {
      title: i18n.t($ => $.objectives.page.title)
    }
  },
  component: lazyRouteComponent($$splitComponentImporter, 'component')
});